function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useEffect, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import Form from "nood-comp/src/comp/form/Form";
import TextField from "nood-comp/src/comp/form/textfield/TextField";
import AddOrEditButton from "nood-comp/src/comp/button/AddOrEditButton";
import CenteredColumnWidth from "nood-comp/src/comp/ui/containers/CenteredColumnWidth";
import Spacer from "nood-comp/src/comp/ui/spacer/Spacer";
import { __post, __put, _get, isHttpWithData } from "nood-comp/src/net/xhr";
import { __feedback } from "src/app/msg";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
export default function PropertyEditor(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    obj = _useState2[0],
    setObj = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    isValid = _useState4[0],
    setIsValid = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    isProcessing = _useState6[0],
    setIsProcessing = _useState6[1];
  var id = useURLParam("id");
  var action = useURLParam("do");
  var _submit = function __submit() {
    if (isValid) {
      if (id) {
        __put("/property/".concat(id), {
          body: JSON.stringify(obj)
        }, function (res) {
          __feedback(res);
        });
      } else {
        __post("/property", {
          body: JSON.stringify(obj)
        }, function (res) {
          __feedback(res);
        });
      }
    }
  };
  useEffect(function () {
    if (id) {
      _get("/property/".concat(id), function (res) {
        var _isHttpWithData;
        setObj((_isHttpWithData = isHttpWithData(res)) !== null && _isHttpWithData !== void 0 ? _isHttpWithData : {});
      });
    }
  }, [id]);
  useEffect(function () {
    if (action && action == "add") {
      setObj(undefined);
    }
  }, [action]);
  return /*#__PURE__*/React.createElement(CenteredColumnWidth, {
    width: 300
  }, /*#__PURE__*/React.createElement(Spacer, {
    mtop: 30
  }), /*#__PURE__*/React.createElement(Form, {
    obj: obj,
    __setter: setObj,
    __validSetter: setIsValid,
    __submit: function __submit(obj, err, submitCallback) {
      _submit();
    }
  }, /*#__PURE__*/React.createElement(TextField, {
    name: "entity",
    validations: ['required'],
    spacer: 10,
    icon: "grid"
  }), /*#__PURE__*/React.createElement(TextField, {
    name: "property_name",
    validations: ['required'],
    spacer: 25,
    icon: "tag"
  }), /*#__PURE__*/React.createElement(AddOrEditButton, {
    obj: "Entity Property",
    valid: isValid,
    processing: isProcessing
  })));
}
PropertyEditor.propTypes = {
  // proptypes
};

// @ts-ignore